export const baseUrl = process.env.REACT_APP_API_BASE_URL;
export const baseUrlSave = process.env.REACT_APP_API_BASE_URL_SAVE_API;

export const createBookingAPI = process.env.REACT_APP_CREATE_BOOKING_API_URL;
export const getAvailableBookingSlotAPI = process.env.REACT_APP_GET_AVAILABLE_BOOKING_SLOT_API_URL;
export const setNewPasswordAPI = process.env.REACT_APP_SET_NEW_PASSWORD_API_URL;
export const getAvailableServicesAPI = process.env.REACT_APP_GET_THE_AVAILABLE_SERVICES_API_URL;

export const azureApiHeader = process.env.REACT_APP_AZURE_API_HEADER;
export const azureApiValue = process.env.REACT_APP_AZURE_API_VALUE;

export const phpBaseUrl = process.env.REACT_APP_PHP_BASE_URL;
export const encryptionIv = process.env.REACT_APP_ENCRYPTION_IV;
export const encryptionKey = process.env.REACT_APP_ENCRYPTION_KEY;

export const defaultImages = {
    serviceProvider : "./assets/images/user.jpg",
}

export const ErrorMsgs = {
    firstStep : {
        postcode : 'Please enter postcode',
        postcodeValid : 'Please enter valid code',
        servicedate : 'Please select service date',
        serviceType : 'Please choose service type'
    },
    thirdStep : {
        firstname : 'Please enter firstname',
        validfirstname : 'Only alphabats are allowed in the first name. ',
        lastname : 'Please enter lastname',
        validlastname : 'Only alphabets are allowed in the last name. ',
        contact : 'Please enter contact number',
        validcontact : 'Please enter 10 digit contact number',
        validcontactnumber : 'Please enter valid contact number',
        email : 'Please enter email address',
        validemail : 'Please enter valid email address',
        address : 'Please enter street address',
        suburb : 'Please enter suburb',
        state : 'Please enter state',
        jobdesc : 'Please add some job description'
    },
    ndisFields : {
        customerFirstName : 'Please enter customer firstname',
        customerLastName : 'Please enter customer lasttname',
        customerContact : 'Please enter customer contact number',
        customerEmail : 'Please enter customer email',
        customerAddress : 'Please enter customer firstname',
        customerSuburb : 'Please enter customer suburb',
        customerState : 'Please enter customer state',
        ndis_registration_id : 'Please enter NDIS Register Id',
        customerNdis_registration_id : 'Please enter Customer NDIS Register Id',
    }
}

export const commercials = 923570000;
export const residential = 923570001;
export const ndis_self_managed = 923570002;
export const ndis_plan_manager = 923570003;

export const commercialsName = 'commercial';
export const residentialName = 'residential';
export const ndis_self_managedName = 'NDIS-self-managed';
export const ndis_plan_managerName = 'NDIS-plan-manager';